// © 2015-2021 WDNA - All Rights Reserved

import api, { AxiosRequestConfig } from '../../../services/api/Connect';

/** Export request types */
export * from './types';

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param id identifier if necessary
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function typeSensor<T = any>(action: string, id?: string, data?: any, options?: AxiosRequestConfig): Promise<T> | undefined {
  const root: string = 'type/sensor';
  switch (action) {
    case 'list':
      return api.post(`${root}/list`, data, options);
    case 'get':
      return id ? api.get(`${root}/get/${id}`, data, options) : undefined;
    case 'set':
      return api.put(`${root}/set`, data, options);
    case 'del':
      return id ? api.delete(`${root}/del/${id}`, data, options) : undefined;
    default:
      return undefined;
  }
}

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param id identifier if necessary
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function typeSensorVariable<T = any>(action: string, id?: string, data?: any, options?: AxiosRequestConfig): Promise<T> | undefined {
  const root: string = 'type/sensor';
  switch (action) {
    case 'list':
      return api.post(`${root}/variable/list?order=order`, data, options);
    case 'get':
      return id ? api.get(`${root}/variable/get/${id}`, data, options) : undefined;
    case 'set':
      return api.put(`${root}/variable/set`, data, options);
    case 'del':
      return id ? api.delete(`${root}/variable/del/${id}`, data, options) : undefined;
    default:
      return undefined;
  }
}

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param id identifier if necessary
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function variable<T = any>(action: string, id?: string, data?: any, options?: AxiosRequestConfig): Promise<T> | undefined {
  const root: string = 'variable';
  switch (action) {
    case 'list':
      return api.post(`${root}/list`, data, options);
    case 'get':
      return id ? api.get(`${root}/get/${id}`, data, options) : undefined;
    case 'set':
      return api.put(`${root}/set`, data, options);
    case 'del':
      return id ? api.delete(`${root}/del/${id}`, data, options) : undefined;
    default:
      return undefined;
  }
}

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param id identifier if necessary
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function parameter<T = any>(action: string, id?: string, data?: any, options?: AxiosRequestConfig): Promise<T> | undefined {
  const root: string = 'param';
  switch (action) {
    case 'list':
      return api.post(`${root}/list`, data, options);
    case 'get':
      return id ? api.get(`${root}/get/${id}`, data, options) : undefined;
    case 'set':
      return api.put(`${root}/set`, data, options);
    case 'del':
      return id ? api.delete(`${root}/del/${id}`, data, options) : undefined;
    default:
      return undefined;
  }
}

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param id identifier if necessary
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function lov<T = any>(action: string, id: string, data?: any, options?: AxiosRequestConfig): Promise<T> | undefined {
  const root: string = 'lov';
  switch (action) {
    case 'statics':
      return api.get(`${root}/statics/${id}`, data, options);
    case 'countries':
      return api.get<T>(`${root}/countries`, data, options);
    case 'timezones':
      return api.get<T>(`${root}/timezones`, data, options);
    default:
      return undefined;
  }
}
